module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("HE")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Z")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("ANZIBAR ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_c('br'), _vm._v("C")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("HEST")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A Story of Life, Love, and Death "), _c('br'), _vm._v("in Foreign Lands")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("IDAN ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ARTLEY")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/V-1.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Grove Press")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-677bc240","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V28911.vue
// module id = 66
// module chunks = 0